import React from "react";

const PlayerMapping = (props) => {
  const player = props.player;
  return (
    <div>
      <img
        className={`w-100 ${props.action === "hited" && props.timerunning ? "shake" : ""}`}
        src={props.action === "hit" ? player.attack : props.action === "static" ? player.waiting : player.hited}
        alt=""
      />
    </div>
  );
};

export default PlayerMapping;
